import React, { useEffect, useState } from "react";
import AppNavigation from "./components/AppNavigation";

const App: React.FC = React.memo((props) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  return <div>{!loading && <AppNavigation />}</div>;
});

export default App;
